import { onMount, onDestroy } from "svelte"
import { readable } from "svelte/store"
import dayjs from "dayjs"

export const now = readable(null, set => {
    const interval = setInterval(() => set(dayjs()), 1000)
    return () => clearInterval(interval)
})
